<template>
  <dashboard-page title="Gestão de Repasses">
    <div class="content mr-3 ml-3 mb-3">
    <modal-loading v-if="isLoading" :openModal="isLoading" :value="99" style="width: 10em;" :label="'Aguarde...'">
    </modal-loading>

    <div>
      <div class="pb-1">

        <b-row class="mb-2 mt-3">
          <b-col>
            <date-picker v-model="formDate.startDate" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" class="w-100 px-0" :clearable="false">
            </date-picker>
          </b-col>

          <b-col>
            <date-picker v-model="formDate.endDate" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" class="w-100" :clearable="false">
            </date-picker>
          </b-col>

          <b-col>
            <base-button @click="loadPayments" :disabled="!formDate.startDate || !formDate.endDate"
              :loading="isLoading" type="submit" class="btn btn-outline-info ml-1" style="padding: 9px 10px 8px 10px;">
              <i class="no no-right-arrow"></i>
            </base-button>
          </b-col>
        </b-row>
      </div>
    </div>

    <div>
      <b-table-simple responsive small max-height="500px" style="overflow-y: auto;" bordered sticky-header empty-text="Sem retiradas registradas.">
        <b-thead>
          <b-tr>
            <b-th sticky-column></b-th>
            <b-th sticky-column>Gestor</b-th>

            <b-th v-for="(period, colIndex) in tablePeriodColumns" :key="'header-' + colIndex">
              {{ period.start }} - {{ period.end }}
            </b-th>
          </b-tr>
        </b-thead>

        <b-tbody>
          <b-tr v-for="(place_uuid, rowIndex) in poisUuids" :key="'row-' + rowIndex">
            <b-th sticky-column>
              <b-button @click="createNewWithdraw(place_uuid, rowIndex)" variant="primary" size="sm" icon>
                <i class="no no-plus text-white"></i>
              </b-button>
            </b-th>

            <b-th sticky-column>
              {{ place_uuid }}
            </b-th>

            <b-td v-for="(period, colIndex) in tablePeriodColumns" :key="'cell-' + rowIndex + '-' + colIndex" class="m-0">
              <b-row v-if="formattedWithdraws[rowIndex][colIndex].length > 0" align-h="start">
                <b-col v-for="(withdraw, withdraw_index) in formattedWithdraws[rowIndex][colIndex]" :key="withdraw_index">
                  <div v-if="withdraw != null && withdraw.id">
                    <span @click="openWithDrawDetails(withdraw)" class="mb-0 h3">
                      <b-badge variant="primary">
                        #{{ withdraw.id }}
                      </b-badge>
                    </span>
                  </div>
                </b-col>

              </b-row>

              <div v-else>
                --
              </div>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>

    <withdraw-sidebar v-if="openWithdrawSidebar" :openWithdrawSidebar="openWithdrawSidebar" @closeWithdrawSidebar="closeWithdrawSidebar()"
      @reloadWithdraws="loadPayments()">
    </withdraw-sidebar>
  </div>
  </dashboard-page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'
import { DatePicker } from "element-ui"
import WithdrawSidebar from './WithdrawSidebar.vue'

export default {
  name: 'WithdrawPage',

  components: {
    ModalLoading,
    DatePicker,
    WithdrawSidebar,
  },

  props: {

  },

  data() {
    return {
      formDate: { startDate: '', endDate: '' }, tablePeriodColumns: [],
      openWithdrawSidebar: false,
    }
  },

  computed: {
    ...mapGetters('withdraw', {
      isLoading: 'getIsLoading',
      attractionsPaymentsList: 'getAttractionsPaymentsList',
      currentWithdraw: 'getCurrentWithdraw',
    }),

    ...mapGetters('auth', {
      place: 'getPlace',
    }),

    ...mapGetters('product', {
      poisList: 'getPois',
    }),

    poisUuids() {
      var uuids = this.attractionsPaymentsList.map(p => { return p.placeUuid || p.place_uuid } ).filter(i => i != null)
      return [... new Set(uuids)]
    },

    formattedWithdraws() {
      let withdraws = [];

      this.attractionsPaymentsList.forEach((withdraw) => {
        if(!withdraw.info.period.start || !withdraw.info.period.end) return;

        const place_idx = this.poisUuids.findIndex(uuid => uuid === withdraw.place_uuid);
        const period_idx = this.tablePeriodColumns.findIndex(p =>
          moment(p.start, "DD/MM/YYYY").isSame(moment(withdraw.info.period.start)) &&
          moment(p.end, "DD/MM/YYYY").isSame(moment(withdraw.info.period.end))
        );

        if(place_idx >= 0 && period_idx >= 0){
          if(!withdraws[place_idx]){ withdraws[place_idx] = new Array(this.tablePeriodColumns.length).fill(null).map(() => []) }
          if(!withdraws[place_idx][period_idx]){ withdraws[place_idx][period_idx] = [] }

          withdraws[place_idx][period_idx].push(withdraw)
        }
      });

      return withdraws
    },

  },

  watch: {

  },

  methods: {
    ...mapActions('withdraw', [
      'fetchPaymentsForAttractions',
      'withdrawStoreCommit',
    ]),

    async loadPayments() {
      await this.fetchPaymentsForAttractions({ startDate: this.formDate.startDate, endDate: this.formDate.endDate })
        .then(() => {
          this.setPeriodColumns()
        })
    },

    setPeriodColumns() {
      var periodDates = this.attractionsPaymentsList.map(w => {
        return { start: moment(w.info.period.start).format("DD/MM/YYYY"), end: moment(w.info.period.end).format("DD/MM/YYYY") }
      })
      periodDates = [...new Map(periodDates.map(date => [date.start, date])).values()]
      periodDates = periodDates.sort((a, b) => moment(a.start,"DD/MM/YYYY").diff(moment(b.start, "DD/MM/YYYY")))  // REMOVING DUPLICATES AND SORTING
      this.tablePeriodColumns = periodDates
    },

    closeWithdrawSidebar(){
      this.openWithdrawSidebar = false
      this.withdrawStoreCommit({ mutation: "RESET_WITHDRAW_BOOKINGS_LIST", value: {} })
    },

    createNewWithdraw(place_uuid, place_index){
      this.withdrawStoreCommit({ mutation: "RESET_CURRENT_WITHDRAW", value: {} })
      var existing_periods = this.formattedWithdraws[place_index].filter(v => v.length > 0)
      var period_index = existing_periods.length - 1
      var withdraws = period_index >= 1 ? existing_periods[period_index] : []
      var last_withdraw = withdraws.length > 0 ? withdraws[withdraws.length - 1] : null
      const last_report_uuid = last_withdraw != null ? last_withdraw.uuid : ""

      this.currentWithdraw.placeUuid = place_uuid
      this.currentWithdraw.last_report_uuid = last_report_uuid
      this.currentWithdraw.info.period.start = last_withdraw ? moment(last_withdraw.info.period.end).add(1, 'd'):moment().startOf('month').format('YYYY-MM-DD')
      this.currentWithdraw.info.period.end = moment(this.currentWithdraw.info.period.start).endOf('month').format('YYYY-MM-DD');
      this.openWithdrawSidebar = true
    },

    openWithDrawDetails(withdraw){
      this.withdrawStoreCommit({ mutation: "SET_CURRENT_WITHDRAW", value: withdraw })
      this.currentWithdraw.last_report_uuid = this.currentWithdraw.info.ref_report_uuid
      this.openWithdrawSidebar = true
    },

  },

  async mounted() {
    this.formDate.startDate = moment().format('YYYY-MM-DD');
    this.formDate.endDate = moment().format('YYYY-MM-DD');
    this.withdrawStoreCommit({ mutation: "RESET_ATTRACTIONS_PAYMENTS_LIST" })
    this.withdrawStoreCommit({ mutation: "RESET_CURRENT_WITHDRAW_PAYMENTS" })
    this.withdrawStoreCommit({ mutation: "RESET_CURRENT_WITHDRAW" })
  },

}
</script>
